import React from 'react'

export default ({
                    checkIn = {heading: 'CHECK-IN', date: '01-01-00'},
                    checkOut,
                    separator = 'dash',
                    increase = null,
                    yearChar = null,
                    children
                }) => {

    const formatDate = date => {
        // Check if date format equals mm-dd-yyyy
        if (!/..-..-.*/g.test(date)) return <div className={'stay-date__date'}>{date}</div>

        let result = separator === 'dot' ? date.replace(/-/g, '.') : date

        if (yearChar) result += ` ${yearChar}`

        return <div className={'stay-date__date'}>
            {increase === 'day' ?
                <span>
                    <span
                        className='stay-date--increase'
                        data-testid={'increase'}>{result.slice(0, 2)}
                     </span>.
                    <span className="stay-date-normal">{result.slice(3)}</span>
                </span> :
                result
            }</div>
    }

    return (
        <div
            data-testid={'stay-date'}
            className={`stay-date ${children ? '' : 'stay-date--empty'}`}
        >
            <div
                data-testid={'check-in'}
                className={'stay-date__item'}
            >
                <div className={'stay-date__heading'}>{checkIn.heading.toUpperCase()}</div>
                {checkIn && formatDate(checkIn.date)}
            </div>
            {checkOut && checkOut.date &&
            <div
                data-testid={'check-out'}
                className={'stay-date__item'}
            >
                <div className={'stay-date__heading'}>{checkOut.heading.toUpperCase()}</div>
                {formatDate(checkOut.date)}
            </div>
            }
            {children}
        </div>
    )
}

